<template>
  <div class="gp-list-loading">
    <template v-if="type == 'page'">
      <div class="gp-list-loading-item align-items-center justify-content-between" v-for="i in quantity" :key="`loading-item-${i}`">
        <div class="col-lg-8">
          <!-- <div class="gp-list-li-img"></div> -->
          <div class="gp-list-li-info">
            <div class="gp-list-li-info-title skeleton skeleton-light"></div>
            <div class="gp-list-li-info-time skeleton skeleton-light"></div>
          </div>
        </div>
        <div class="gp-list-li-stat col">
          <div class="gp-list-li-status skeleton skeleton-light"></div>
        </div>
        <div class="gp-list-li-actions">
          <div class="gp-list-li-preview skeleton skeleton-light mr-1"></div>

          <div class="gp-list-li-tool skeleton skeleton-light"></div>
        </div>
      </div>
    </template>

    <template v-if="type == 'assignment'">
      <div class="gp-list-loading-item gp-lli-assignment" v-for="i in quantity" :key="`loading-item-${i}`">
        <div class="col-md-1 d-flex align-items-center">
          <div class="gp-list-li-img medium"></div>
        </div>
        <!-- <div class="col-lg-3" /> -->
        <div class="col-md-6 d-flex align-items-center">
          <div class="gp-list-li-info ml-0">
            <div class="gp-list-li-info-title mb-0"></div>
          </div>
        </div>
        <div class="col-md-4 d-flex align-items-center">
          <div class="gp-list-li-info ml-0">
            <div class="gp-list-li-info-title mb-0 large"></div>
          </div>
        </div>

        <div class="col-md-1 d-flex align-items-center">
          <div class="gp-list-li-img tiny"></div>
        </div>
      </div>
    </template>

    <template v-if="type == 'recent'">
      <div class="col-xl-3 col-mlg-4 col-lg-6 d-flex" v-for="i in quantity" :key="`loading-item-${i}`">
        <div class="recent-loading-item">
          <div class="recent-loading-item-thumbnail"></div>
          <div class="recent-loading-item-info">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5111 0.666992H3.33333C2.59695 0.666992 2 1.26395 2 2.00033V14.0003C2 14.7367 2.59695 15.3337 3.33333 15.3337H12.6667C13.403 15.3337 14 14.7367 14 14.0003V3.91536C14 3.53439 13.837 3.17161 13.5522 2.91858L11.3966 1.00354C11.1526 0.786739 10.8375 0.666992 10.5111 0.666992ZM3.33332 11.3336V2.00036H9.33332V5.36699C9.33332 5.73518 9.63179 6.03366 9.99998 6.03366H11.658C12.0262 6.03366 12.3247 5.73518 12.3247 5.36699C12.3247 4.9988 12.0262 4.70033 11.658 4.70033H10.6667V2.13859L12.6667 3.9154V11.3336H3.33332ZM3.33332 12.667V14.0004H12.6667V12.667H3.33332Z" fill="#CDCFD1" />
            </svg>
            <p class="typo-title1 info-item title"></p>
            <p class="typo-tiny11 info-item time"></p>
          </div>
          <div class="recent-loading-item-actions flex-v-center mb-n2 mx-n2 pb-2 px-2">
            <p class="action-item flex-v-center edit typo-body2"></p>
            <p class="action-item ion flex-v-center edit typo-body2"></p>
            <div class="action-item-tool"></div>
          </div>
        </div>
      </div>
    </template>

    <template v-if="type == 'shop'">
      <div class="gp-list-loading-item" v-for="i in quantity" :key="`loading-item-${i}`">
        <div class="col-7 col-mlg-5">
          <div class="gp-list-li-info">
            <div class="gp-list-li-info-name"></div>
            <div class="gp-list-li-info-domain"></div>
          </div>
        </div>
        <div class="col-3 col-mlg-2">
          <div class="gp-list-li-info">
            <div class="gp-list-li-info-name"></div>
            <div class="gp-list-li-info-domain"></div>
          </div>
        </div>
        <div class="col-2 col-mlg-5">
          <div class="gp-list-li-access"></div>

          <div class="gp-list-li-tool"></div>
        </div>
      </div>
    </template>

    <template v-if="type == 'rightsection'">
      <div class="right-section-loading p-2 d-flex flex-column">
        <div class="title skeleton skeleton-light"></div>
        <div class="search-field my-2">
          <p class="h14 w60 skeleton skeleton-light"></p>
        </div>
        <div class="items mb-2">
          <div class="item col-12" :key="'loading-assign-item' + i" v-for="i in quantity">
            <div class="img mr-2 skeleton skeleton-light"></div>
            <div class="name h14 w60 skeleton skeleton-light"></div>
          </div>
        </div>
        <div class="d-flex flex-column flex-grow-1">
          <div class="btn btn-block btn-default skeleton skeleton-light mt-auto"></div>
        </div>
        <!-- <div class="position-relative full-width full-height">
          <GLoading size="small" />
        </div> -->
      </div>
    </template>

    <template v-if="type == 'filter-search'">
      <div class="filter-search-loading"></div>
    </template>

    <template v-if="type == 'pagetype-name'">
      <div class="pagetype-name-loading"></div>
    </template>
  </div>
</template>

<script>
export default {
  name: "ListLoading",
  props: {
    type: {
      type: String,
      default: "page"
    },
    quantity: {
      type: Number,
      default: 5
    }
  }
};
</script>

<style lang="scss">
@import "@/core/themes/partials/_animation.scss";

.gp-list-loading {
  .gp-list-loading-item {
    background: #ffffff;
    border-radius: $radius;
    margin-bottom: 24px;
    position: relative;
    cursor: pointer;
    min-height: 80px;
    display: flex;
    flex-direction: row;

    // @include skeleton("light");
  }
}

.gp-list-li {
  &-info {
    &-title {
      height: 16px;
      width: 80%;
      margin-bottom: 3px;
      max-width: 360px;
    }
    &-time {
      width: 40%;
      max-width: 150px;
      height: 12px;
    }
  }
  &-count {
    width: 80px;
    height: 12px;
    margin-left: auto;
  }

  &-stat {
    justify-content: center;
    align-items: flex-end;
    display: flex;
    flex-direction: column;
  }

  &-status {
    max-width: 120px;
    width: 100%;
    height: 12px;
  }

  &-actions {
    display: flex;
    padding: 0 16px;
  }

  &-preview, &-tool {
    $size: 40px;
    width: $size;
    height: $size;
    border-radius: $radius;
  }

}

.recent-loading {
  margin-left: -24px;
  margin-right: -24px;

  &-item {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    border-radius: 10px;
    flex: 1;
    margin-top: 24px;
    padding: 16px;
    min-height: calc(318px);
    background: $neutral5;

    &-thumbnail {
      display: flex;
      flex: 1;
      max-height: 171px;
      margin-bottom: 16px;
      border-radius: 10px 10px 0 0;
      @include skeleton("light");
    }

    &-info {
      display: flex;
      flex-direction: column;
      min-height: 21px;

      > svg {
        margin-bottom: 12px;
      }

      .info-item {
        flex: 1;
        min-height: 21px;
        @include skeleton("light");
      }

      .title {
        margin-bottom: 12px;
      }

      .time {
        width: 40%;
        min-height: 16px;
      }
    }

    &-actions {
      margin-top: 32px;
      padding-bottom: 24px !important;

      .action-item {
        min-height: 18px;
        padding: 5px 1px;
        margin-right: 24px;
        flex-wrap: wrap;
        flex: 0.33;
        @include skeleton("light");
      }

      .action-item-tool {
        min-width: 4.5px;
        height: 21px;
        position: absolute;
        right: 32px;
        @include skeleton("light");
      }
    }
  }
}

.right-section-loading {
  width: 312px;
  height: 560px;
  margin-left: 24px;
  background: $light1;
  border-radius: $radius;
  border: 1px solid $neutral1;

  .title {
    height: 16px;
    width: 150px;
  }
  .h14 {
    height: 14px;
  }
  .w60 {
    width: 60%;
  }
  .search-field {
    padding-left: 16px;
    height: 40px;
    display: flex;
    align-items: center;
  }
  .items {
    display: flex;
    flex-direction: column;;
  }
  .item {
    padding: 4px 28px 4px 20px;
    border-bottom: 1px solid $light3;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-shrink: 1;
    .img {
      width: 50px;
      height: 42px;
    }
  }
}

.filter-search-loading {
  width: 480px;
  height: 30px;
  @include skeleton("light");
}

.pagetype-name-loading {
  width: 120px;
  height: 30px;
  @include skeleton("light");
}

@media only screen and (max-width: 480px) {
  .gp-list-loading {
    &-item {
      .gp-list-li-info {
        &-title {
          &.mw-6 {
            max-width: 100% !important;
          }
        }
      }
    }
  }
}
</style>
